module.exports = __webpack_public_path__ + "img/menuIcon18.3ddf8ab4.png";